/* eslint-disable template-curly-spacing */
// @flow
import BaseWagTheme from '@waglabs/webapp-theme';
import { createGlobalStyle } from 'styled-components';

import GrilledCheeseTTF from './assets/grilled-cheese.ttf';
import GrilledCheeseEOT from './assets/grilled-cheese.eot';
import GrilledCheeseWOFF from './assets/grilled-cheese.woff';
import GrilledCheeseWOFF2 from './assets/grilled-cheese.woff2';

import MuliTTF from './assets/muli-v16-latin-regular.ttf';
import MuliWOFF from './assets/muli-v16-latin-regular.woff';
import MuliWOFF2 from './assets/muli-v16-latin-regular.woff2';
import MuliSVG from './assets/muli-v16-latin-regular.svg';

export const GlobalStyle = createGlobalStyle`
  ol, ul {
    padding: 0 20px; /* Remove default 40px padding, but align bullet points with content */
  }

  body {
    margin: 0;
  }

  p {
    font-family: ${props => props.theme.fonts.body};
  }

  a {
    text-decoration: none;
  }

  @font-face {
  font-family: "GrilledCheeseBTN";
  font-display: swap;
  src: url(${GrilledCheeseTTF}) format("truetype"),
      url(${GrilledCheeseEOT}) format("embedded-opentype"),
      url(${GrilledCheeseWOFF}) format("woff"),
      url(${GrilledCheeseWOFF2}) format("woff2");
  }

  @font-face {
    font-family: 'Muli';
    font-style: normal;
    font-weight: 500;
    src: local('Muli'), local('Muli'),
        url(${MuliTTF}) format('truetype'), /* Safari, Android, iOS */
        url(${MuliWOFF}) format('woff'), /* Modern Browsers */
        url(${MuliWOFF2}) format('woff2'), /* Super Modern Browsers */
        url(${MuliSVG}) format('svg'); /* Legacy iOS */
  }

  .bold {
    font-weight: bold;
  }

  a {
    color: ${props => props.theme.colors.wagGreen};
    text-decoration: none;
  }
}

${'' /* this selector is a workround until we investigate why the error fields are not matching
        wag-react theme for the forms: [NV-375]
*/}
.wag-tag__form-field + div {
  font-size: 14px;
}
`;

const buttons = {
  ...BaseWagTheme.buttons,
  disabled: {
    backgroundColor: BaseWagTheme.colors.backgroundGray,
    color: BaseWagTheme.colors.medGray,
  },
  green: {
    backgroundColor: BaseWagTheme.colors.wagGreen,
    color: BaseWagTheme.colors.white,
  },
  transparent: {
    bg: BaseWagTheme.colors.transparent,
    color: BaseWagTheme.colors.wagGreen,
  },
};

const fonts = {
  heading: '"GrilledCheeseBTN", Helvetica, Arial, sans-serif',
  body: '"Helvetica Neue Regular", Helvetica, Arial, sans-serif',
  bodyMuli: 'Muli, "Helvetica Neue Regular", Helvetica, Arial, sans-serif',
};

const lineHeights = [
  1,
  1.125,
  1.25,
  1.5,
];

const colors = {
  ...BaseWagTheme.colors,
  borderGray: '#D1D1D1',
  medGray: '#727272',
  gray: '#777777',
  navyBlue: '#3D5080',
  wagGold: '#FAAB43',
  backgroundYellow: '#FAE7A8',
  lightBrown: '#7B5533',
  lightBlue: '#81ABCE',
  lightGray: '#F7F7F7',
  linkBlue: '#4A90E2',
  brown4: '#90704A',
  appInstallBannerBackground: '#EDEDED',
  shelterGreen: '#2A7C70',
};

export const Theme = {
  ...BaseWagTheme,
  buttons,
  fonts,
  colors,
  lineHeights,
};
